import { create } from 'zustand'

type EventLeadCaptureState = {
  quickFormOpen: boolean
  openQuickForm: () => void
  closeQuickForm: () => void
}

export const useEventLeadCaptureStore = create<EventLeadCaptureState>((set) => ({
  quickFormOpen: false,
  openQuickForm: () => set({ quickFormOpen: true }),
  closeQuickForm: () => set({ quickFormOpen: false }),
}))
